module.exports = __webpack_public_path__ + "img/fj.871fc14d.svg";